import ko from 'knockout'
import template from './index.html'
import Base from '../../core/base'
import {
  resetScrollEffect
} from '../../util/scrollable'

// const FORMAT = 'hh:mm'
// 获取元素距离窗口左侧距离
const getElementLeft = function (element) {
  var actualLeft = element.offsetLeft
  var current = element.offsetParent
  while (current !== null) {
    actualLeft += current.offsetLeft
    current = current.offsetParent
  }
  return actualLeft
}
class DatePicker extends Base {
  initialize ({
    placeholder,
    position,
    data,
    dropStyle,
    disabled = false,
    gridRef = false,
    hasSeconds = false
  }) {
    this.dropStyle = dropStyle
    this.placeholder = placeholder
    if (position === 'top') {
      this.isTop = true
    } else {
      this.isTop = false
    }
    // 默认不包含秒
    this.hasSeconds = hasSeconds
    this.data = data
    this.hour = ko.observable()
    this.minutes = ko.observable()
    this.seconds = ko.observable()
    this.alignright = ko.observable(false)
    if (!ko.isObservable(disabled)) {
      disabled = ko.observable(disabled)
    }
    this.disabled = disabled
    this.isPopup = ko.observable(false)
    this.setFocus = () => {
      this.$el.querySelector('.y-input').click()
      this.$el.querySelector('.y-input').focus()
    }
    this.setUnFoucs = () => {
      this.isPopup(false)
    }
  }
  computed (params) {
    this.computedData = ko.computed(() => {
      return this.data()
    })
  }
  methods (params) {
    this.onMaskHover = () => {
      resetScrollEffect()
    }
    // 选中输入框
    this.focus = (data, event) => {
      let leftPosition = getElementLeft(event.target)
      // 获取viewport 宽度
      let screenWidth = document.documentElement.clientWidth
      try {
        // 如果元素距离右侧的距离小于280 则将弹出浮动款左移，设置right：0
        if (screenWidth - leftPosition < 280) {
          this.alignright(true)
        } else {
          this.alignright(false)
        }
      } catch (e) {
        console.error(e)
      }
      this.isPopup(true)
      var getData = this.data()
      if (getData && getData.indexOf(':') > 0) {
        var dataArry = getData.split(':')
        this.hour(parseInt(dataArry[0]))
        this.minutes(parseInt(dataArry[1]))
        if (this.hasSeconds) {
          // 可能默认值有问题
          this.seconds(parseInt(dataArry[2] || 0))
        }
      } else {
        var d = new Date()
        this.hour(d.getHours())
        this.minutes(d.getMinutes())
        if (this.hasSeconds) {
          this.seconds(d.getSeconds())
        }
      }
    }
    this.nexthour = () => {
      let _hour = this.hour() + 1
      if (_hour === 24) {
        this.hour(0)
      } else {
        this.hour(_hour)
      }
    }
      // 小时选择长按
    var timerTimeout
    var innerInterval
    this.nexthourholddown = () => {
      timerTimeout = setTimeout(() => {
        innerInterval = setInterval(() => {
          this.nexthour()
        }, 100)
      }, 200)
    }
    this.holdup = () => {
      clearInterval(innerInterval)
      clearTimeout(timerTimeout)
    }
    this.blur = () => {
      clearInterval(innerInterval)
      clearTimeout(timerTimeout)
    }
    // 小时手动输入
    this.blurHour = (e) => {
      let _hour = e.target.value.replace(/\D/g, '')
      if (_hour >= 24 || _hour <= 0) {
        this.hour(0)
        e.target.value = '00'
      } else {
        this.hour(_hour)
      }
    }
    this.lasthour = () => {
      let _hour = this.hour() - 1
      if (_hour <= 0) {
        this.hour(23)
      } else {
        this.hour(_hour)
      }
    }
    this.lasthourholddown = () => {
      timerTimeout = setTimeout(() => {
        innerInterval = setInterval(() => {
          this.lasthour()
        }, 100)
      }, 200)
    }
    this.nextminutes = () => {
      let _minutes = this.minutes() + 1
      if (_minutes >= 60) {
        this.minutes(0)
      } else {
        this.minutes(_minutes)
      }
    }
      // 分钟手动输入
    this.blurMinutes = (e) => {
      let _minutes = e.target.value.replace(/\D/g, '')
      if (_minutes >= 60 || _minutes <= 0) {
        this.minutes(0)
        e.target.value = '00'
      } else {
        this.minutes(_minutes)
      }
    }
      // 分钟选择长按
    this.nextminholddown = () => {
      timerTimeout = setTimeout(() => {
        innerInterval = setInterval(() => {
          this.nextminutes()
        }, 50)
      }, 200)
    }
    this.lastminutes = () => {
      let _minutes = this.minutes() - 1
      if (_minutes <= 0) {
        this.minutes(59)
      } else {
        this.minutes(_minutes)
      }
    }
      // 分钟选择长按
    this.lastminholddown = () => {
      timerTimeout = setTimeout(() => {
        innerInterval = setInterval(() => {
          this.lastminutes()
        }, 50)
      }, 200)
    }
    this.nextseconds = () => {
      let _seconds = this.seconds() + 1
      if (_seconds >= 60) {
        this.seconds(0)
      } else {
        this.seconds(_seconds)
      }
    }
      // 分钟手动输入
    this.blurSeconds = (e) => {
      let _seconds = e.target.value.replace(/\D/g, '')
      if (_seconds >= 60 || _seconds <= 0) {
        this.seconds(0)
        e.target.value = '00'
      } else {
        this.seconds(_seconds)
      }
    }
      // 秒选择长按
    this.nextsecholddown = () => {
      timerTimeout = setTimeout(() => {
        innerInterval = setInterval(() => {
          this.nextseconds()
        }, 50)
      }, 200)
    }
    this.lastseconds = () => {
      let _seconds = this.seconds() - 1
      if (_seconds <= 0) {
        this.seconds(59)
      } else {
        this.seconds(_seconds)
      }
    }
      // 秒选择长按
    this.lastsecholddown = () => {
      timerTimeout = setTimeout(() => {
        innerInterval = setInterval(() => {
          this.lastseconds()
        }, 50)
      }, 200)
    }
    this.onInput = (e) => {
      let val = parseFloat(e.target.value)
      if (!/^[0-9]*[1-9][0-9]*$/.test(val)) {
        e.target.value = '00'
      }
    }
    // 遮罩点击
    this.maskClick = () => {
      this.isPopup(false)
    }
    //
    this.confirm = () => {
      this.bindModelValue()
      this.closeModal()
    }
    this.bindModelValue = () => {
      var hour = this.hour()
      var minutes = this.minutes()
      var seconds = this.seconds()
      if (hour < 10) {
        hour = '0' + Number(hour)
      }
      if (minutes < 10) {
        minutes = '0' + Number(minutes)
      }
      if (seconds < 10) {
        seconds = '0' + Number(seconds)
      }
      var time = hour + ':' + minutes
      if (this.hasSeconds) {
        time += ':' + seconds
      }
      this.data(time)
    }
    this.generateDate = () => {}
    // 关闭弹框
    this.closeModal = () => {
      this.isPopup(false)
    }
  }
  created (params) {
    // 初始化值
    this.generateDate(this.data())
  }
}
export default {
  name: 'timepicker',
  init: Base.createViewModel(DatePicker),
  template
}



// WEBPACK FOOTER //
// ./src/components/timepicker/index.js